import * as React from "react";

export const IconCalendarMatch = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.75 3.375H11.125V2.375C11.125 2.30625 11.0688 2.25 11 2.25H10.125C10.0562 2.25 10 2.30625 10 2.375V3.375H6V2.375C6 2.30625 5.94375 2.25 5.875 2.25H5C4.93125 2.25 4.875 2.30625 4.875 2.375V3.375H2.25C1.97344 3.375 1.75 3.59844 1.75 3.875V14.25C1.75 14.5266 1.97344 14.75 2.25 14.75H13.75C14.0266 14.75 14.25 14.5266 14.25 14.25V3.875C14.25 3.59844 14.0266 3.375 13.75 3.375ZM13.125 13.625H2.875V7.6875H13.125V13.625ZM2.875 6.625V4.5H4.875V5.25C4.875 5.31875 4.93125 5.375 5 5.375H5.875C5.94375 5.375 6 5.31875 6 5.25V4.5H10V5.25C10 5.31875 10.0562 5.375 10.125 5.375H11C11.0688 5.375 11.125 5.31875 11.125 5.25V4.5H13.125V6.625H2.875Z"
      fill="#767B7E"
    />
  </svg>
);
